import { render } from "./App.vue?vue&type=template&id=5e30a79e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=5e30a79e&lang=scss"

import exportComponent from "/Users/macmeow/Documents/vue/feedback_page/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__